import { render, staticRenderFns } from "./AddTicketModal.vue?vue&type=template&id=fba585b0&"
import script from "./AddTicketModal.vue?vue&type=script&lang=js&"
export * from "./AddTicketModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTicketModal.vue?vue&type=style&index=0&id=fba585b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports